import React, { Component } from "react";
import "./styles.css";
import { Form, Radio, Segment, Icon, Button } from "semantic-ui-react";
import {
  validateOnlyLetters,
  validateEmail,
  validatePhone,
  errorMsgs,
} from "../../../../commons/functions/formValidations";
import { COUNTRIES_CODE } from "../../../../data/locations";
import { connect } from "react-redux";
import { getMunicipalities } from "../../../../redux/actions/municipalities";
const moment = require("moment-timezone");
moment.tz.setDefault("America/Tegucigalpa");

class FormInfoContact extends Component {
  constructor(props) {
    super(props);
    const { formInfo } = this.props;

    this.state = {
      names: formInfo.names,
      surnames: formInfo.surnames,
      email: formInfo.email,
      code: formInfo.code,
      phone: formInfo.phone,
      recipientCode: formInfo.recipientCode,
      recipientPhone: formInfo.recipientPhone,
      recipientName: formInfo.recipientName,
      addressLine1: formInfo.addressLine1,
      addressLine2: formInfo.addressLine2,
      department: formInfo.department,
      municipality: formInfo.municipality,
      // postal: formInfo.postal,
      notifications: formInfo.notifications,
      date: formInfo.date,
      afternoon: formInfo.afternoon,
      disableRadio: false,
      saturday: false,
    };
    this.handleSubmitMyAddresses = this.handleSubmitMyAddresses.bind(this);
  }

  componentDidMount() {
    const { date } = this.props.formInfo;
    this.handleValidationDate(date.value);
    const names = localStorage.getItem("names");
    const phone = localStorage.getItem("phone");
    const surnames = localStorage.getItem("surnames");
    const email = localStorage.getItem("email");
    const recipientName = localStorage.getItem("recipientName");
    const recipientPhone = localStorage.getItem("recipientPhone");
    const addressLine1 = localStorage.getItem("addressLine1");
    const addressLine2 = localStorage.getItem("addressLine2");

    if (names) this.setState({ names: { value: names, error: "" } });
    if (surnames) this.setState({ surnames: { value: surnames, error: "" } });
    if (recipientName)
      this.setState({ recipientName: { value: recipientName, error: "" } });
    if (phone) this.setState({ phone: { value: phone, error: "" } });
    if (recipientPhone)
      this.setState({ recipientPhone: { value: recipientPhone, error: "" } });
    if (email) this.setState({ email: { value: email, error: "" } });
    if (addressLine1)
      this.setState({ addressLine1: { value: addressLine1, error: "" } });
    if (addressLine2)
      this.setState({ addressLine2: { value: addressLine2, error: "" } });

    /*   moment(date.value).day() === 0
    ? this.setState({
          date: { value: date.value, error: errorMsgs.disabledSunday },
        })
      : this.setState({ date: { value: date.value, error: "" } }); */

    const today = moment().format("YYYY-MM-DD");

    const daySaturday = "Saturday";
    const daySunday = "Sunday";
    const ValidationSaturday =
      moment(today).format("dddd") === daySaturday &&
      parseInt(moment().format("HH")) >= 11 &&
      moment(date.value).isSame(today);

    const ValidationSunday =
      moment(today).format("dddd") === daySunday &&
      moment(date.value).isSame(today);
    if (
      moment(date.value).format("dddd") === daySaturday &&
      ValidationSaturday
    ) {
      const dateRefactoring = moment(date.value).add(2, "days");
      const newDate = moment(dateRefactoring).format("YYYY-MM-DD");
      this.setState({ date: { value: newDate, error: "" } });
    } else if (
      moment(today).format("dddd") === daySaturday &&
      moment(date.value).format("dddd") === daySunday
    ) {
      const dateRefactoring = moment(date.value).add(1, "days");
      const newDate = moment(dateRefactoring).format("YYYY-MM-DD");
      this.setState({ date: { value: newDate, error: "" } });
    } else if (
      moment(date.value).format("dddd") === daySunday &&
      ValidationSunday
    ) {
      const dateRefactoring = moment(date.value).add(1, "days");
      const newDate = moment(dateRefactoring).format("YYYY-MM-DD");
      this.setState({ date: { value: newDate, error: "" } });
    }
  }

  handleValidationDate = (date) => {
    const today = moment().format("YYYY-MM-DD");
    if (
      Number(moment().format("HH")) > 10 &&
      Number(moment().format("HH")) < 12 &&
      moment(date).isSame(moment(today))
    ) {
      this.setState({ disableRadio: true });
    } else {
      this.setState({ disableRadio: false });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.department !== this.state.department ||
      prevState.municipality !== this.state.municipality
    ) {
      this.props.setFormInfo(this.state);
    }
    if (prevProps.formInfo.names !== this.props.formInfo.names) {
      this.setState({
        names: this.props.formInfo.names,
        surnames: this.props.formInfo.surnames,
        email: this.props.formInfo.email,
      });
    }
  }

  handleSetLocalStorage = (name, value) => {
    localStorage.setItem(name, value);
    this.setState({ [name]: { value, error: "" } });
  };

  handleRemoveLocalStorage = (name, value) => {
    localStorage.removeItem(name);
    this.setState({ [name]: { value, error: errorMsgs.required } });
  };

  handleGetMunicipality = (name, value) => {
    const departament = JSON.parse(value);
    const valueDepartament = departament;

    this.setState({
      [name]: { value: valueDepartament.name, error: "" },
    });

    this.props.getMunicipalities(valueDepartament.id);
  };

  handleSelectMunicipality = (name, value) => {
    const municipality = JSON.parse(value);
    const valueMunicipality = municipality;
    this.setState({
      [name]: { value: valueMunicipality.name, error: "" },
    });
    this.props.handleShippingCost(valueMunicipality.shippingCost);
  };

  handleChange = (e, { name, value, key }) => {
    const today = moment().format("YYYY-MM-DD");

    switch (name) {
      case "names":
      case "surnames":
      case "recipientName":
        validateOnlyLetters(value)
          ? this.handleSetLocalStorage(name, value)
          : value === ""
          ? this.handleRemoveLocalStorage(name, value)
          : value.length === 1
          ? this.setState({ [name]: { value, error: errorMsgs.atLeastTwo } })
          : this.setState({ [name]: { value, error: errorMsgs.lettersOnly } });
        break;
      case "email":
        validateEmail(value)
          ? this.handleSetLocalStorage(name, value)
          : value === ""
          ? this.handleRemoveLocalStorage(name, value)
          : this.setState({ [name]: { value, error: errorMsgs.email } });
        break;

      case "code":
        // value !== ""
        //   ? this.handleSetLocalStorage(name, value)
        //   : this.setState({ [name]: { value, error: errorMsgs.required } });
        break;

      case "phone":
      case "recipientPhone":
        validatePhone(value) && value !== ""
          ? this.handleSetLocalStorage(name, value)
          : value === ""
          ? this.handleRemoveLocalStorage(name, value)
          : this.setState({ [name]: { value, error: errorMsgs.phone } });
        break;
      case "recipientCode":
        // value !== ""
        //   ? this.handleSetLocalStorage(name, value)
        //   : this.setState({ [name]: { value, error: errorMsgs.required } });
        break;

      case "department":
        value !== ""
          ? this.handleGetMunicipality(name, value)
          : this.handleGetMunicipality(name, value);

        break;

      case "municipality":
        value !== ""
          ? this.handleSelectMunicipality(name, value)
          : this.handleSelectMunicipality(name, value);

        break;

      case "notifications":
        this.setState({
          [name]: !this.state.notifications,
        });
        break;

      case "afternoon":
        Number(moment().format("HH")) > 10 &&
        moment(this.state.date.value).isSame(moment(today)) &&
        value === "false"
          ? this.setState({
              [name]: { value, error: errorMsgs.morningNotAllowed },
            })
          : this.setState({ [name]: { value, error: "" } });
        break;
      case "addressLine1":
        value && value !== ""
          ? this.handleSetLocalStorage(name, value)
          : this.handleRemoveLocalStorage(name, value);

        break;
      case "addressLine2":
        value && value !== ""
          ? this.handleSetLocalStorage(name, value)
          : localStorage.removeItem(name);
        break;
      case "date":
        this.handleValidationDate(value);
        Number(moment().format("HH")) > 10 &&
        moment(value).isSame(moment(today)) &&
        this.state.afternoon.value === "false"
          ? this.setState({
              afternoon: { value: "false", error: errorMsgs.morningNotAllowed },
            })
          : this.setState({
              afternoon: { value: this.state.afternoon.value, error: "" },
            });

        value === ""
          ? this.setState({ [name]: { value, error: errorMsgs.required } })
          : moment(value).diff(moment(), "days") < 0
          ? this.setState({ [name]: { value, error: errorMsgs.earlyDate } })
          : // : moment(today + " 15:00", "YYYY-MM-DD hh:mm").diff(
          //     moment(),
          //     "hours"
          //   ) <= 0 && moment(value).diff(moment()) < 0
          // ? this.setState({ [name]: { value, error: errorMsgs.earlyDate3pm } })
          (moment(value).format("dddd") === "Saturday" &&
              moment(today).format("dddd") === "Saturday" &&
              parseInt(moment().format("HH")) >= 11 &&
              moment(value).isSame(today)) ||
            (moment(today).format("dddd") === "Sunday" &&
              moment(value).format("dddd") === "Sunday" &&
              moment(value).isSame(today))
          ? this.setState({
              [name]: { value: "false", error: errorMsgs.disabledSunday },
            })
          : (moment(value).month() === 11 &&
              [24, 25, 26, 27, 31].includes(moment(value).date())) ||
            (moment(value).month() === 0 &&
              [1, 2, 3].includes(moment(value).date()))
          ? this.setState({
              [name]: { value, error: errorMsgs.holidaysDeliveryNotAllowed },
            })
          : this.setState({ [name]: { value, error: "" } });

        break;
      default:
        value !== ""
          ? this.setState({ [name]: { value, error: "" } })
          : this.setState({ [name]: { value, error: errorMsgs.required } });
        break;
    }
  };
  getFieldsFromState = () => {
    const {
      names,
      surnames,
      email,
      // code,
      // recipientCode,
      phone,
      addressLine1,
      addressLine2,
      department,
      municipality,
      recipientPhone,
      recipientName,
      date,
      afternoon,
      //postal
    } = this.state;
    const fields = {
      names,
      surnames,
      email,
      // code,
      // recipientCode,
      phone,
      recipientName,
      recipientPhone,
      addressLine1,
      addressLine2,
      department,
      municipality,
      date,
      afternoon,
      // postal
    };
    return fields;
  };
  hasErrors = () => {
    const fields = this.getFieldsFromState();
    for (const prop in fields) {
      if (fields[prop].error !== "") {
        return true;
      }
    }
    return false;
  };
  hasErrorsStepZero = () => {
    const {
      names,
      surnames,
      email,
      phone,
      // code,
      recipientCode,
    } = this.state;
    const step0Fields = {
      names,
      surnames,
      email,
      phone,
      // code,
      recipientCode,
    };
    for (const prop in step0Fields) {
      if (step0Fields[prop].error !== "") {
        return true;
      }
    }
    return false;
  };
  handleSubmit = (e) => {
    const {
      names,
      surnames,
      email,
      // code,
      phone,
    } = this.state;
    const step0Fields = {
      names,
      surnames,
      email,
      // code,
      phone,
    };
    const fields = this.getFieldsFromState();
    let hasErrors = false;
    if (this.props.step === 0) {
      for (const prop in step0Fields) {
        if (step0Fields[prop].value === "") {
          this.setState({ [prop]: { value: "", error: errorMsgs.required } });
          hasErrors = true;
        }
      }
      if (!hasErrors && !this.hasErrorsStepZero()) {
        this.props.goToStepOne();
      }
    }
    if (this.props.step === 1) {
      for (const prop in fields) {
        if (fields[prop].value === "") {
          if (prop !== "addressLine2") {
            this.setState({
              [prop]: { value: "", error: errorMsgs.required },
            });
            hasErrors = true;
          }
        }
      }

      if (!hasErrors && !this.hasErrors()) {
        this.props.goToStepTwo(this.state);
      }
    }
  };

  myAddresses(addresses) {
    const customAddresses = [];
    addresses.forEach((address) => {
      customAddresses.push({
        key: address.addressId,
        text: address.name,
        value: address.addressId,
      });
    });
    return customAddresses;
  }

  handleSubmitMyAddresses(e, { value }) {
    let addressSelected = {};
    this.props.addresses.addresses.forEach((address) => {
      if (value === address.addressId) {
        addressSelected = address;
      }
    });
    this.setState({
      addressLine1: { value: addressSelected.addressLine1, error: "" },
      addressLine2: { value: addressSelected.addressLine2, error: "" },
    });
  }
  render() {
    const {
      names,
      surnames,
      email,
      code,
      phone,
      addressLine1,
      addressLine2,
      recipientCode,
      recipientPhone,
      department,
      municipality,
      recipientName,
      // postal,
      notifications,
      date,
      afternoon,
    } = this.state;

    const {
      step,
      goToStepZero,
      validWordsLetter,
      addresses,
      authentication,
      departaments,
      municipalities,
    } = this.props;

    return (
      <Segment>
        <Form onSubmit={this.handleSubmit} autoComplete="off">
          {step === 0 && (
            <div>
              <h5 className="info-contact-form-title">
                Información del comprador
              </h5>
              <Form.Group unstackable widths={2}>
                <Form.Input
                  onChange={this.handleChange}
                  label={
                    <label>
                      Nombres <span className="form-info-required">*</span>
                    </label>
                  }
                  name="names"
                  type="text"
                  value={names.value}
                  placeholder="Nombres"
                  error={
                    names.error !== "" && {
                      content: names.error,
                      pointing: "above",
                    }
                  }
                />
                <Form.Input
                  onChange={this.handleChange}
                  label={
                    <label>
                      Apellidos <span className="form-info-required">*</span>
                    </label>
                  }
                  name="surnames"
                  value={surnames.value}
                  type="text"
                  placeholder="Apellidos"
                  error={
                    surnames.error !== "" && {
                      content: surnames.error,
                      pointing: "above",
                    }
                  }
                />
              </Form.Group>
              <Form.Input
                onChange={this.handleChange}
                label={
                  <label>
                    Correo eléctronico{" "}
                    <span className="form-info-required">*</span>
                  </label>
                }
                name="email"
                value={email.value}
                type="email"
                placeholder="Correo electrónico"
                error={
                  email.error !== "" && {
                    content: email.error,
                    pointing: "below",
                  }
                }
              />
              <Form.Group unstackable widths={1}>
                {false && (
                  <Form.Select
                    onChange={this.handleChange}
                    label={
                      <label>
                        Código de país
                        <span className="form-info-required">*</span>
                      </label>
                    }
                    options={COUNTRIES_CODE}
                    placeholder="Código"
                    width={7}
                    fluid
                    error={
                      code.error !== "" && {
                        content: code.error,
                        pointing: "above",
                      }
                    }
                    name="code"
                    defaultValue={code.value}
                  />
                )}
                <Form.Input
                  onChange={this.handleChange}
                  label={
                    <label>
                      Teléfono móvil{" "}
                      <span className="form-info-required">*</span>
                    </label>
                  }
                  type="tel"
                  name="phone"
                  width={9}
                  value={phone.value}
                  placeholder="Teléfono móvil"
                  error={
                    phone.error !== "" && {
                      content: phone.error,
                      pointing: "above",
                    }
                  }
                />
              </Form.Group>
              <Form.Button
                content="Continuar"
                className="info-contact-submit-button"
                disabled={this.hasErrorsStepZero()}
              />
            </div>
          )}
          {step === 1 && (
            <div>
              <div className="form-info-return-container">
                <a
                  href="!#"
                  onClick={(e) => {
                    e.preventDefault();
                    goToStepZero();
                  }}
                  className="form-info-return-link"
                >
                  <Icon name="arrow left" /> Regresar
                </a>
              </div>
              <Form.Input
                onChange={this.handleChange}
                label={
                  <label>
                    Nombre completo de la persona que recibirá las flores{" "}
                    <span className="form-info-required">*</span>
                  </label>
                }
                name="recipientName"
                value={recipientName.value}
                type="text"
                placeholder="Nombre completo"
                error={
                  recipientName.error !== "" && {
                    content: recipientName.error,
                    pointing: "below",
                  }
                }
              />
              <Form.Group unstackable widths={1}>
                {false && (
                  <Form.Select
                    onChange={this.handleChange}
                    label={
                      <label>
                        Código de país
                        <span className="form-info-required">*</span>
                      </label>
                    }
                    options={COUNTRIES_CODE}
                    placeholder="Código"
                    width={6}
                    fluid
                    error={
                      recipientCode.error !== "" && {
                        content: recipientCode.error,
                        pointing: "above",
                      }
                    }
                    name="recipientCode"
                    defaultValue={recipientCode.value}
                  />
                )}
                <Form.Input
                  onChange={this.handleChange}
                  width={10}
                  label={
                    <label className="recipientPhone">
                      Teléfono móvil de la persona que recibirá las flores{" "}
                      <span className="form-info-required">*</span>
                    </label>
                  }
                  placeholder="Teléfono móvil"
                  name="recipientPhone"
                  value={recipientPhone.value}
                  error={
                    recipientPhone.error !== "" && {
                      content: recipientPhone.error,
                      pointing: "above",
                    }
                  }
                />
              </Form.Group>
              <Form.Input
                onChange={this.handleChange}
                type="date"
                name="date"
                start="1"
                end="5"
                error={
                  (date.error !== "" || afternoon.error !== "") && {
                    content: date.error !== "" ? date.error : afternoon.error,
                    pointing: "below",
                  }
                }
                className="form-info-date"
                label={
                  <label>
                    Fecha de entrega{" "}
                    <span className="form-info-required">*</span>
                  </label>
                }
                defaultValue={date.value}
              />
              <Form.Group>
                <Form.Field error={afternoon.error !== "" && afternoon.error}>
                  <Radio
                    label="Entegar por la mañana"
                    name="afternoon"
                    value="false"
                    checked={afternoon.value === "false"}
                    onChange={this.handleChange}
                    disabled={this.state.disableRadio}
                  />
                </Form.Field>
                <Form.Field>
                  <Radio
                    label="Entregar por la tarde"
                    name="afternoon"
                    value="true"
                    checked={afternoon.value === "true"}
                    onChange={this.handleChange}
                  />
                </Form.Field>
              </Form.Group>

              {addresses.addresses.length > 0 && !authentication.isEmpty ? (
                <Form.Select
                  onChange={this.handleSubmitMyAddresses}
                  options={this.myAddresses(addresses.addresses)}
                  label={<label>Mis direcciones</label>}
                  placeholder="Utiliza las direcciones de tu cuenta"
                  name="addressLine1"
                  className="info-form-select"
                  defaultValue={addressLine1.value}
                />
              ) : null}

              <Form.Input
                onChange={this.handleChange}
                label={
                  <label>
                    Dirección de envío de las flores{" "}
                    <span className="form-info-required">*</span>
                  </label>
                }
                placeholder="Dirección de envío"
                name="addressLine1"
                value={addressLine1.value}
                error={
                  addressLine1.error !== "" && {
                    content: addressLine1.error,
                    pointing: "below",
                  }
                }
              />
              <Form.Input
                onChange={this.handleChange}
                label="Detalles de dirección de envío (opcional)"
                placeholder="N. de apartamento, piso de apartamento, etc."
                name="addressLine2"
                value={addressLine2.value}
                error={
                  addressLine2.error !== "" && {
                    content: addressLine2.error,
                    pointing: "below",
                  }
                }
              />

              <Form.Select
                onChange={this.handleChange}
                options={departaments.departaments}
                label={
                  <label>
                    Departamento <span className="form-info-required">*</span>
                  </label>
                }
                placeholder="Escoge el departamento"
                name="department"
                className="info-form-select"
                error={
                  department.error !== "" && {
                    content: department.error,
                    pointing: "below",
                  }
                }
                defaultValue={department.value}
              />

              <Form.Select
                onChange={this.handleChange}
                options={municipalities.municipalities}
                label={
                  <label>
                    Municipio <span className="form-info-required">*</span>
                  </label>
                }
                placeholder="Escoge el municipio"
                name="municipality"
                className="info-form-select"
                error={
                  municipality.error !== "" && {
                    content: municipality.error,
                    pointing: "below",
                  }
                }
                defaultValue={municipality.value}
              />
              {/* <Form.Input
                onChange={this.handleChange}
                label={
                  <label>
                    Código postal <span className="form-info-required">*</span>
                  </label>
                }
                name="postal"
                value={postal.value}
                placeholder="Código postal"
                error={
                  postal.error !== "" && {
                    content: postal.error,
                    pointing: "below"
                  }
                }
              /> */}

              <Form.Checkbox
                onChange={this.handleChange}
                name="notifications"
                className="font-weight-bold"
                label="Quiero recibir noticias y ofertas"
                checked={notifications}
              />
              <div className="info-contact-submit-button">
                <Button
                  disabled={this.hasErrors() || !validWordsLetter}
                  type="submit"
                  className="btn btn-black text-white"
                >
                  Confirmar
                </Button>
              </div>
            </div>
          )}
        </Form>
      </Segment>
    );
  }
}

const mapStateToProps = ({ municipalities }) => ({
  municipalities,
});
export default connect(mapStateToProps, {
  getMunicipalities,
})(FormInfoContact);
